/* eslint-disable react/prop-types */
import { Navigate, Outlet } from "react-router-dom";
import { useSession } from "@hooks/useSession";
import { Box, Skeleton } from "@mui/material";

const ProtectedRoute = ({ allowedRoles = [] }) => {
  const { session, loading } = useSession();

  if (loading) {
    return (
      <Box
        sx={{ width: "100%", display: "flex", justifyContent: "center", mt: 3 }}
      >
        <Skeleton variant="rectangular" width="100%" height={400} />
      </Box>
    );
  }

  if (!session) {
    return <Navigate to="/sign-in" replace />;
  }

  // If allowedRoles is provided, restrict access accordingly
  if (allowedRoles.length && !allowedRoles.includes(session.user_type)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
